import * as React from 'react';

type MapContext = {
  map: google.maps.Map | undefined;
  setMap: React.Dispatch<React.SetStateAction<google.maps.Map | undefined>>;
};

type MapProviderProps = {
  children: React.ReactNode;
};

const MapContext = React.createContext<MapContext | undefined>(undefined);

export const MapProvider: React.FC<MapProviderProps> = ({ children }) => {
  const [map, setMap] = React.useState<google.maps.Map>();

  const contextValue: MapContext = React.useMemo(
    () => ({ map, setMap }),
    [map]
  );

  return (
    <MapContext.Provider value={contextValue}>{children}</MapContext.Provider>
  );
};

export const useMap = () => {
  const context = React.useContext(MapContext);

  if (context === undefined) {
    throw new Error('useMap must be used within a MapProvider');
  }

  return context;
};
